import { BaseApi } from './base.api.js';

export class ObjectiveApi extends BaseApi {
    constructor(client) {
        super(client, '/objective');
    }

    async getRelatedTreatments(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/treatments`, { params });
        return response.data;
    }

    async addTreatments(id, treatmentIds) {
        const response = await this.client.post(`${this.basePath}/${id}/treatments`, { treatmentIds });
        return response.data;
    }

    async removeTreatment(id, treatmentId) {
        const response = await this.client.delete(`${this.basePath}/${id}/treatments/${treatmentId}`);
        return response.data;
    }

    async getRelatedKpis(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/kpis`, { params });
        return response.data;
    }

    async addKpis(id, kpiIds) {
        const response = await this.client.post(`${this.basePath}/${id}/kpis`, { kpiIds });
        return response.data;
    }

    async removeKpi(id, kpiId) {
        const response = await this.client.delete(`${this.basePath}/${id}/kpis/${kpiId}`);
        return response.data;
    }

    async getRelatedInitiatives(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/initiatives`, { params });
        return response.data;
    }

    async addInitiatives(id, initiativeIds) {
        const response = await this.client.post(`${this.basePath}/${id}/initiatives`, { initiativeIds });
        return response.data;
    }

    async removeInitiative(id, initiativeId) {
        const response = await this.client.delete(`${this.basePath}/${id}/initiatives/${initiativeId}`);
        return response.data;
    }
}
